import { isVueAppInDOM, renderApp } from '@/src/shared/component-utilities';

import ForgotPassword from './ForgotPassword.vue';

export function load() {
  const selector = 'zel-forgot-password';

  if (!isVueAppInDOM(selector)) {
    return;
  }

  renderApp(ForgotPassword, selector);
}
